import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AppContextComponent, withContext } from './context/appContext';
import { AuthProvider } from './context/authContext';

const AppWithContext = withContext()(() => (
  <AuthProvider>
    <App />
  </AuthProvider>
));
const root = createRoot(document.getElementById('root'));
(async function load() {
  root.render(
    <AppContextComponent>
      <AppWithContext />
    </AppContextComponent>,
  );
}());
